import { API_BASE } from "../apiConfig";

function sanitizeClientProps(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return {};
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Object.keys(out).length >= 12) break;
    const key = String(k).replace(/[^\w.-]/g, "").slice(0, 32);
    if (!key) continue;
    if (typeof v === "string") out[key] = v.slice(0, 160);
    else if (typeof v === "number" && Number.isFinite(v)) out[key] = v;
    else if (typeof v === "boolean") out[key] = v;
  }
  return out;
}

/**
 * First-party usage event (server logs JSONL). Fire-and-forget; failures ignored.
 * @param {string} name lowercase_snake event id (a-z, 0-9, _)
 * @param {Record<string, string|number|boolean>} [props]
 * @param {string} [lang] he | en | es
 */
export function logProductEvent(name, props = {}, lang) {
  if (typeof window === "undefined" || !name) return;
  const n = String(name)
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, "")
    .slice(0, 64);
  if (!n) return;
  let path = "";
  try {
    path = `${window.location.pathname}${window.location.search || ""}`.slice(0, 400);
  } catch {
    /* ignore */
  }
  const body = {
    name: n,
    props: sanitizeClientProps(props),
    path,
    lang: typeof lang === "string" ? lang.slice(0, 12) : undefined,
  };
  fetch(`${API_BASE}/api/analytics/event`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).catch(() => {});
}
